import Vue from 'vue'
import VueI18n from 'vue-i18n'

import esLocale from './locale/es'
import enLocale from './locale/en'
// import esCoLocale from './locale/esCo'

Vue.use(VueI18n)

const messages = {
  es: esLocale,
  en: enLocale
  // 'es-co': esCoLocale
}

const i18n = new VueI18n({
  locale: 'es',
  messages
})

export default i18n
